import React, { createContext, useState } from 'react';

export const UserContext = createContext();

const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isTraining, setIsTraining] = useState(false);

    return (
        <UserContext.Provider value={{ user, setUser ,isTraining , setIsTraining}}>
            {children}
        </UserContext.Provider>
    );
};

export { UserProvider }; // Export UserProvider
